module.exports = __webpack_public_path__ + "images/functional-icon.png";